import { Container } from "reactstrap"

const SpecialInstructions = () => {

  const giftWrappingPolicies = [

    'Only high-quality wrapping paper is allowed',
    'Additional cost must be reasonable and justifiable',
    'Wrapping paper options should be updated regularly',
    'No offensive or inappropriate wrapping paper designs'

  ]

  const personalizedMessagePolicies = [

    'Messages must not exceed the character limit set',
    'No offensive, harmful, or inappropriate content in messages',
    'Should review messages for compliance',
    'Messages should be printed clearly and legibly'

  ]

  const specialInstructionsPolicies = [

    `Instructions must be feasible and within the seller's capabilities`,
    'No requests that violate safety or legal standards',
    'Must follow instructions precisely',
    'Additional costs must reflect the effort and resources required'

  ]

  return (
    <Container fluid>
      <h5 className="fw-medium my-3">Gift Wrapping Policies</h5>

      <div className="bg-white p-1">
        <div className="m-1" style={{ border: '2px solid #D9D9D9' }}>

          <ul style={{ margin: '1rem .5rem' }}>
            {giftWrappingPolicies?.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>

        </div>
      </div>


      <h5 className="fw-medium my-3">Personalized Message Policies</h5>
      <div className="bg-white p-1">
        <div className="m-1" style={{ border: '2px solid #D9D9D9' }}>
          <ul style={{ margin: '1rem .5rem' }}>
            {personalizedMessagePolicies?.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </div>

      <h5 className="fw-medium my-3">Special Instructions Policies</h5>
      <div className="bg-white p-1">
        <div className="m-1" style={{ border: '2px solid #D9D9D9' }}>
          <ul style={{ margin: '1rem .5rem' }}>
            {specialInstructionsPolicies?.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </Container>
  )
}

export default SpecialInstructions
